import React, {Component} from 'react';
import Styles from './style.css';
import {langRegister} from "../../services/langRegister";
import cx from "classnames";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";

class ModalStopCampaign extends Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    };

    componentWillMount() {}

    _close(){
        this.props.stop(false);
    }

    _terminate(){
        this.props.terminate();
    }


    _renderText(item) {
        return langRegister.get("modal-stopcampaign", item);
    }

    render() {
        return (
              <div className={Styles.overlay}>
                  <div className={Styles.overlayModal}>
                      <div className={Styles.overlayModalInner}>
                          {
                              salesChannelRegister.get('name')!=='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon.svg")}/>
                          }
                          {
                              salesChannelRegister.get('name')==='yieldlock' &&
                              <img onClick={() => this._close()}
                                   className={Styles.overlayCloseButton}
                                   src={require("../../assets/images/close_icon_yl.svg")}/>
                          }
                          <div>
                              <div className={Styles.overlayModalText}>
                                  <span style={salesChannelRegister.get('name')==='yieldlock'?{color: '#E65032'}:{}} className={Styles.overlayModalTextRed}>{this._renderText("item_1")}{" "}</span><span className={Styles.overlayModalTextBold} style={salesChannelRegister.get('name')==='yieldlock'?{color: '#00273A'}:{}}>{this._renderText("item_2")}</span>
                              </div>
                          </div>
                      </div>
                      <div className={Styles.overlayModalButtons}>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div onClick={() => {this._close()}} className={cx([Styles.overlayModalButtonsItemButton])}>
                                  {this._renderText("item_4")}
                              </div>
                          </div>
                          <div className={Styles.overlayModalButtonsItem}>
                              <div style={salesChannelRegister.get('name')==='yieldlock'?{backgroundColor: '#E65032'}:{}} onClick={() => {this._terminate()}} className={cx([Styles.overlayModalButtonsItemButton, Styles.buttonActive])}>
                                  {this._renderText("item_3")}
                              </div>
                          </div>
                      </div>
                  </div>
              </div>
        );
    }
}

export default ModalStopCampaign;


// WEBPACK FOOTER //
// ./src/components/modal_stopcampaign/component.js